import type { Theme } from '@mui/material';

// import type { Components } from '@mui/material/styles';
import { SHAPE_CIRCULAR, SHAPE_SQUARE } from '@/mui/constants';

export const CUSTOM_ATTRIBUTE_SHAPE = 'data-0';

export default function MUIInputBase(theme: Theme) /*: Components['MuiInputBase']*/ {
  return {
    // defaultProps: {},
    variants: [
      {
        props: { [CUSTOM_ATTRIBUTE_SHAPE]: SHAPE_SQUARE },
        style: {
          borderRadius: 0,
        },
      },
      {
        props: { [CUSTOM_ATTRIBUTE_SHAPE]: SHAPE_CIRCULAR },
        style: {
          borderRadius: '100vw',
        },
      },
    ],
    styleOverrides: {
      root: {
        padding: theme.spacing(0, 0, 0, 3),
        '&.Mui-disabled': {
          '& svg': {
            color: theme.palette.text.disabled,
          },
        },
      },
      input: {
        lineHeight: 1.4,
        '&::placeholder': {
          opacity: 1,
          color: theme.palette.text.secondary,
        },
      },
    },
    // variants: [],
  };
}
